<template>
    <v-container fluid style = 'padding:0;'>

      <!-- Draft Booking Flow Component - Baseline variant -->
      <DraftBookingFlow_baseline 
        v-if="draftBookingCode && variant === 'baseline'"
        :draftBookingCode="draftBookingCode"
        :utmSource="utm_source"
        :utmMedium="utm_medium"
        :utmCampaign="utm_campaign"
        @restart="handleRestart"
      />

      <!-- Draft Booking Flow Component - Treatment Category First variant -->
      <DraftBookingFlow_treatment_category_first 
        v-else-if="draftBookingCode && variant === 'treatment_category_first'"
        :draftBookingCode="draftBookingCode"
        :utmSource="utm_source"
        :utmMedium="utm_medium"
        :utmCampaign="utm_campaign"
        @restart="handleRestart"
      />

    </v-container>
  </template>
  
<script>

import api from '@/api';
import axios from 'axios';
import DraftBookingFlow_baseline from '@/components/DraftBookingFlow_baseline.vue';
import DraftBookingFlow_treatment_category_first from '@/components/DraftBookingFlow_treatment_category_first.vue';

export default {
    name: 'HomeView',
    components: {
      DraftBookingFlow_baseline,
      DraftBookingFlow_treatment_category_first
    },
    data: () => ({
      variant: 'baseline',
      draftBookingCode: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      isRestarting: false,
    }),
    methods: {
      async createEmptyBooking() {
        let headers = await api.getApiHeaders();
        try {
          let response = await axios.post(api.getApiUrl('u/draft-booking/create'), {
            utm_source: this.utm_source,
            utm_medium: this.utm_medium,
            utm_campaign: this.utm_campaign,
            variant: this.variant
          }, { headers });
          this.draftBookingCode = response.data.code;
        } catch (error) {
          console.error(error);
        }
      },
      async handleRestart() {
        // Set restarting flag to maintain the same component/variant
        this.isRestarting = true;
        
        // Clear the current draft booking code
        const previousCode = this.draftBookingCode;
        this.draftBookingCode = null;
        
        // Small delay to ensure the component unmounts properly
        await this.$nextTick();
        
        try {
          // Create a new draft booking with the SAME variant
          await this.createEmptyBooking();
        } catch (error) {
          console.error('Error restarting booking:', error);
          // If restart fails, restore the previous code
          this.draftBookingCode = previousCode;
        } finally {
          this.isRestarting = false;
        }
      }
    },
    async mounted() {
      try {
        const urlParams = new URLSearchParams(window.location.search);

        // Extract UTM parameters from URL or localStorage
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign'];

        utmKeys.forEach(key => {
          let value = urlParams.get(key);
          if (!value) {
            value = localStorage.getItem(`bookingapp_${key}`);
          }
          if (value) {
            this[key] = value;
            localStorage.setItem(`bookingapp_${key}`, value);
          }
        });

        this.variant = Math.random() < 0.5 ? 'baseline' : 'treatment_category_first';
        // Check for "variant" in the URL query string and override if present
        const variantQuery = urlParams.get('variant');
        if (variantQuery) {
          this.variant = variantQuery;
        }

        
        await this.createEmptyBooking();
      } catch (error) {
        console.error(error);
      }
    },
};
</script>
<style lang="scss">

$primaryDark: #32598C;
$primaryLight: #00B0DA;
$accent: #F25631;
$error: #FF4B55;
$button: #00B0DA;

DIV.home-wrapper {
  > DIV.stage-item {
    min-height:calc(100vh - 373px);
    display:flex;
    flex-direction:column;
    justify-content:space-between;

    @media (max-width: 1250px) {
      min-height:calc(100vh - 377px);
    }
  }
}


.progress-indicator {
  margin-top:20px;
  display: flex;  
  margin-bottom: 20px;

  > DIV:nth-child(1), > DIV:nth-child(3), > DIV:nth-child(5) {   
    > SPAN {
      display:inline-block;
      width:40px;
      height:40px;
      text-align:center;
      border-radius: 30px;
      background-color: #FFF;
      color:$primaryDark;
      border: 2px solid $primaryDark;
      padding-top:4px;
      font-size: 20px;
      font-weight:500;      
    }

    &.progress-indicator-selected {
      > SPAN {
        background-color: $accent;
        color:#FFF;
        border:2px solid $accent;
      }
    }
  }

  > DIV:nth-child(2), > DIV:nth-child(4) {
    width: 100%;
    height: 1px;
    margin-top: 19px;

    > HR {
      border-color: $primaryDark;
      border-style:solid;
    }
  
  }

}

.section-container {
  margin-top: 20px;
}

.v-field {
  border-radius: 9px !important;
}

/* Form Fields */
.form-field {
  margin-top:20px;
  font-size: 15px;
  font-weight: 500;
  &.address_string {
    INPUT {
      border-radius: 9px;
      border: 1px solid rgba(0, 0, 0, 0.4);
      width:100%;
      height:3.5rem;
      padding-left:15px;
      color: rgba(0, 0, 0, 0.87);
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.4);

    }
    INPUT::placeholder {
      color: rgba(0, 0, 0, 0.4);      
    }

    input:focus {
      border: 2px solid rgba(0, 0, 0, 0.87);
    }

  }

  .v-selection-control-group LABEL, .v-selection-control LABEL {
    color: #000;
    opacity: 1;
  }

  .v-selection-control {
    .v-icon {
      color: $primaryLight;
    }
  }

  &.treatment-list .v-selection-control-group {
    > DIV {
      margin-top:20px;
      &:first-child {
        margin-top:0;
      }
    }
  }


}

.scheduling_preferences_by_day_add_date {
  display: flex;
  font-size:15px;
  margin-top:20px;
  width:100%;
  border-radius: 9px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  color: #00000066;
  padding: 8px;
  cursor: pointer;

  > DIV {
    vertical-align: middle;
  }

  > DIV:first-child {
    margin-right:10px;
  }

  > DIV:last-child {
    margin-left:auto;
    color:$accent;
  }
}

.scheduling_preferences_by_day_add_date:hover {
  border: 1px solid rgba(0, 0, 0, 0.6);
  color: #00000088;
}

.preferred-date-add-scheduling-preference {
  margin-top:10px;
  padding: 8px;
  display:flex;  
  
  > DIV {
    width:33.33%; 
    &:nth-child(1) {
      padding-right:5px;
    }
    &:nth-child(2) {
      padding-left:5px;
      padding-right:5px;
    }      
    &:nth-child(3) {
      padding-left:5px;      
    }  
  }    
  BUTTON {      
    width:100%;
    color: #000;
    border-color: #00000066;     
    border-radius: 9px;
    text-transform: none;
  }
  
  .preferred-date-button-selected {
    BUTTON {
      color: #FFF;
      background-color: $accent;      
    }
  }

}

.scheduling_preferences_by_day_item {
  margin-bottom:20px;
  &:last-child {
    margin-bottom:0;
  }
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 9px;
  color: #00000066; 
  
  > DIV:first-child {
    display: flex;
    padding: 8px;
    > DIV {
      vertical-align: middle;
    }
    > DIV:first-child {
      color:$accent;
      margin-right:10px;
    }
    > DIV:nth-child(2) {
      font-weight:700;
      color:#000;
      font-size:15px;
    }
    > DIV:last-child {
      margin-left:auto;
      color:$accent;
    }  
  }

  > DIV:last-child {
    padding: 8px;
    display:flex;
    > DIV {
      width:33.33%; 
      &:nth-child(1) {
        padding-right:5px;
      }
      &:nth-child(2) {
        padding-left:5px;
        padding-right:5px;
      }      
      &:nth-child(3) {
        padding-left:5px;      
      }      
    }
    BUTTON {      
      width:100%;
      color: #00000066; 
      border-color: #00000066;     
      border-radius: 9px;
      text-transform: none;
    }
    
    .preferred-date-button-selected {
      BUTTON {
        color: #FFF;
        background-color: $accent;      
      }
    }
  }




}



.vc-bordered {
  border:0 !important;
}

.vc-highlight-content-solid {
  color:#FFF;
}

.vc-highlight-bg-solid {
  background-color:$accent !important;
}

.vc-title-wrapper {
  font-size: 18px;
  font-weight: 700;
}

.confirm_verification_content {
  margin-top:0;
  text-align:center;

  DIV.confirm_verification_content_icon {
    font-size: 60px;
    color: $accent;
    text-align:center;
  }

  DIV.confirm_verification_content_title {
    font-size: 16px;
    font-weight: 700;
    text-align:center;
  }

  DIV.confirm_verification_content_text {
    &:first-child {
      margin-top:30px;
    }
    font-size: 15px;
    text-align:center;
    margin-top:20px;
    margin-left:auto;
    margin-right:auto;
    width:220px;
  }

  DIV.confirm_verification_content_trouble {
    font-size: 15px;
    text-align:center;
    margin-top:20px;
    A {
      color: $accent;
      text-decoration: underline;
    }
  }

}

DIV.treatment_need_help {
  margin-top: 20px;
  text-align:center;
  A {
      color: $accent;
      text-decoration: underline;
    }
}

DIV.agreed_to_terms {
  margin-top:60px;
  font-size: 15px;
  font-weight: 500;
  text-align:center;
  color: #00000066;

  .v-selection-control LABEL {
    color: #000;
    opacity: 1;
    A {
      color: $accent;
      text-decoration: underline;
    }
  }
}


DIV.verification-trouble {  
  margin-top:40px;
  font-size: 15px;
  text-align:center;
  A {
    color: $accent;
    text-decoration: underline;
  }
}


.thank_you_content {
  margin-top:50px;
  text-align:center;

  DIV.thank_you_content_icon {
    font-size: 60px;
    color: $accent;
    text-align:center;
  }

  DIV.thank_you_content_title {
    font-size: 16px;
    font-weight: 700;
    text-align:center;

  }

  DIV.thank_you_content_text {
    font-size: 15px;
    text-align:center;
    margin-top:20px;
    width:220px;
    margin-left:auto;
    margin-right:auto;
  }

}




.form-error {
  margin-top:20px;
  color: $error;
  font-size:15px;
  font-weight:500;
}


.error-overlay-content {
  width:300px;
  min-height:360px;
  background-color:#FFF;
  border-radius: 9px;
  padding:30px;
  padding-left:40px;
  padding-right: 40px;

  > DIV.sad-face {
    text-align:center;
    font-size: 60px;
    color: $accent;
  }

  > H2 {
    text-align:center;
    font-size: 18px;
    font-weight:700;
    color: $primaryDark;
    margin-top:20px;
  }

  > DIV.error-overlay-description {
    text-align:center;
    font-size: 20px;
    color: $primaryDark;
    margin-top:20px;    
    font-size:15px;
    font-weight:500;
    
    A {
      color: $accent;
      text-decoration: underline;
    }
  }

}

DIV.invalid-verification-code {
  margin-top:20px;
  text-align:center;
  font-size: 15px;

  > DIV {
    margin-top:20px;
  }
  A {
    color: $accent;
    text-decoration: underline;
  }
}

DIV.form-field-error {
  div.v-field__overlay {
    border:2px solid $error !important;
  }
  &.address_string {
    INPUT {
      border: 2px solid $error;
    }
  }
}

.v-list-item {
  color: #000;
}

.v-list-item:hover {
  background-color: #DDF0FD;
}

</style>
